// About.jsx

import React from "react";
import "./ProfessionalInformation.css";
import { Link } from "react-router-dom";
import Roofrepair from './Category/Roofrepair';







export default function ProfessionalInformation() {


  const items = [
    { title: " תיקון גגות", img: "/images/21.jpg", path: "/Roofrepair"},
    { title: "  איטום קירות חיצוניים", img: "/images/35.jpeg" , path: "/Sealingexteriorwalls"},
    { title: " שיקום מבנים", img: "/images/58.jpeg" , path: "/BuildingRehabilitation"},
    { title: " זיפות גגות", img: "/images/36.jpeg", path: "/Rooftarps"},
    { title: "   יריעות ביטומניות  ", img: "/images/37.jpeg" , path: "/Bituminoussheets"},
    { title: "    איטום גגות ביריעות ביטומניות  ", img: "/images/69.jpg" , path: "/Waterproofingroofswithbituminoussheets"},
    { title: "    יריעות איטום לגג ", img: "/images/61.jpg" , path: "/Roofwaterproofingsheets"},
    { title: "      סוגי יריעות ביטומניות ", img: "/images/62.jpg" , path: "/Types_of_bituminous_sheets"},
    { title: "      זפת חם", img: "/images/16.jpg" , path: "/Hot_tar"},
    { title: "עבודה בגובה", img: "/images/5.jpg" , path: "/Working_at_Height"},
    { title: "עבודות סנפלינג", img: "/images/63.jpg" , path: "/Working_in_abseiling"},
    { title: "איטום בסנפלינג", img: "/images/64.jpg" , path: "/Abseiling_sealing"},
    { title: "גשם זה טוב - לא בתוך הבית ", img: "/images/38.jpeg" , path: "/Rain_is_good_but_not_in_doors"},
    { title: "   איתור נזילות", img: "/images/39.jpeg" , path: "/Leak_detection"},
    { title: "כיצד לבחור בעל מקצוע לאיטום גגות", img: "/images/40.jpeg" , path: "/How_to_choose_a_professional_for_roof_waterproofing"},
    { title: "  שיטות שונות לאיטום גגות", img: "/images/41.jpeg" , path: "/Different_methods_of_roof_sealing"},
    { title: "  גרים בקומת גג בבניין ? כדאי שתדאגו לאיטום הגג", img: "/images/42.jpeg" , path: "/Live_on_the_roof_floor_in_a_building"},
  ];







  return (

    <div className="ProfessionalInformation-page">
      <div className="ProfessionalInformation-hero">
        <div className="ProfessionalInformation-overlay">
          <h1> מידע מקצועי</h1>
        </div>

<div>
</div>
</div>

    <div className="page2">
 <div className="breadcrumb2">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>
</div>



       <div className="grid2">
          {items.map((item, index) => (
            
            <Link to={item.path} key={index} className="card2">

              <img src={item.img} alt={item.title} />

              <div className="card2-btn">
                {item.title}
              </div>

            </Link>
        ))}
      </div>
    </div>


      </div>
  );
}


